import type { CasOrCategory, ChemicalExemptionID, ProductExemptionTypeID } from '../types/db.ts';

export const ChemicalExemptionTypeIds = {
  DeMinimis: 0 as ChemicalExemptionID,
  NonFibrousAluminumOxide: 1 as ChemicalExemptionID,
  NonFumeOrDustAluminum: 2 as ChemicalExemptionID,
  NonFumeOrDustZinc: 3 as ChemicalExemptionID,
  NonManufacturedIsopropylAlcohol: 4 as ChemicalExemptionID,
  NonAirborneSulfuricAcid: 5 as ChemicalExemptionID,
  AqueousAmmonia: 6 as ChemicalExemptionID,
  NonAqueousNonAnhydrousAmmonia: 7 as ChemicalExemptionID,
  NonWaterDissociableNitrateCompounds: 8 as ChemicalExemptionID,
};

export const ChemicalExemptionTypeNames: Record<ChemicalExemptionID, string> = {
  [ChemicalExemptionTypeIds.DeMinimis]: 'De minimis',
  [ChemicalExemptionTypeIds.NonFibrousAluminumOxide]: 'Non-fibrous aluminum oxide',
  [ChemicalExemptionTypeIds.NonFumeOrDustAluminum]: 'Aluminum not in fume or dust form',
  [ChemicalExemptionTypeIds.NonFumeOrDustZinc]: 'Zinc not in fume or dust form',
  [ChemicalExemptionTypeIds.NonManufacturedIsopropylAlcohol]: 'Isopropyl alcohol is only reportable when manufactured.',
  [ChemicalExemptionTypeIds.NonAirborneSulfuricAcid]: 'Sulfuric acid is only reportable when airborne.',
  [ChemicalExemptionTypeIds.AqueousAmmonia]: 'Only 10% of aqueous ammonia is reportable.',
  [ChemicalExemptionTypeIds.NonAqueousNonAnhydrousAmmonia]: 'Ammonia not in aqueous nor anhydrous forms.',
  [ChemicalExemptionTypeIds.NonWaterDissociableNitrateCompounds]: 'Nitrate compounds not water dissociable.',
};

const ammonias = [
  // Normal ammonia:
  '7664-41-7',
  // Ammonium hydroxide (ammonia in water):
  '1336-21-6',
  // Ammonium chloride:
  '12125-02-9',
] as CasOrCategory[];

export const chemicalExemptionsByCasOrCategory: ({
  chemicalExemptionID: ChemicalExemptionID;
} & ({ cas: CasOrCategory } | { category: CasOrCategory }))[] = [
  {
    cas: '1344-28-1' as CasOrCategory,
    chemicalExemptionID: ChemicalExemptionTypeIds.NonFibrousAluminumOxide,
  },
  {
    cas: '7429-90-5' as CasOrCategory,
    chemicalExemptionID: ChemicalExemptionTypeIds.NonFumeOrDustAluminum,
  },
  {
    cas: '7440-66-6' as CasOrCategory,
    chemicalExemptionID: ChemicalExemptionTypeIds.NonFumeOrDustZinc,
  },
  {
    cas: '67-63-0' as CasOrCategory,
    chemicalExemptionID: ChemicalExemptionTypeIds.NonManufacturedIsopropylAlcohol,
  },
  {
    cas: '7664-93-9' as CasOrCategory,
    chemicalExemptionID: ChemicalExemptionTypeIds.NonAirborneSulfuricAcid,
  },
  ...ammonias.map((cas) => ({
    cas,
    chemicalExemptionID: ChemicalExemptionTypeIds.AqueousAmmonia,
  })),
  {
    cas: '7664-41-7' as CasOrCategory,
    chemicalExemptionID: ChemicalExemptionTypeIds.NonAqueousNonAnhydrousAmmonia,
  },
  {
    category: 'N511' as CasOrCategory,
    chemicalExemptionID: ChemicalExemptionTypeIds.NonWaterDissociableNitrateCompounds,
  },
];

export const ProductExemptionTypeIds = {
  Article: 1 as ProductExemptionTypeID,
};

export const ProductExemptionTypeNames: Record<ProductExemptionTypeID, string> = {
  [ProductExemptionTypeIds.Article]: 'Article',
};
